export const URL = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL || "",
  LIST_OF_EMPLOYEES_STATUS: "api/getActiveEmployeesList",
  LOGOUT: "authn/logoutUser",
  LOGIN_V: "loginv",
};
